module.exports = __webpack_public_path__ + "static/media/img_23.93e24f42.png";